<template>
  <footer class="footer">
    <main>
      <a-row>
        <a-col :span="18">
          <div><img :src="require('@/assets/images/footer/logo.png')"></div>
          <div>{{ t('footer.intro') }}</div>
        </a-col>
        <a-col :span="4">
          <div>
            <div>{{ t('footer.officialSite') }}</div>
            <div>http://www.sunther.com</div>
          </div>
          <div>
            <div>{{ t('footer.hotline') }}</div>
            <div>86 ( 10 ) 84464096</div>
          </div>
          <div>
            <div>{{ t('footer.serviceEmail') }}</div>
            <div>userservice@sunther.com</div>
          </div>
        </a-col>
        <a-col :span="2">
          <div>{{ t('footer.followUs') }}</div>
          <div><img :src="require('@/assets/images/footer/code.png')"></div>
        </a-col>
      </a-row>
      <div class="bottom">{{ t('footer.copyright') }}</div>
    </main>
  </footer>
</template>

<script>
import { t } from '@/locales';

export default {
  methods: { t },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
